import {svgIconWrapper} from '../svg-icon-wrapper';

import QuickbooksRegular from './quickbooks-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    const {fill: _fill, color: _color, ...rest} = props;

    return <QuickbooksRegular {...rest} />;
}

SvgComponent.iconName = 'quickbooksRegular';

export const QuickbooksRegularIcon = svgIconWrapper(SvgComponent);
